<template>
  <v-container fluid class="order-page pa-4">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "order",

  created() {
    document.title = "smplsale - Order";
  },
};
</script>

<style scoped>
.order-page {
  background: #f8fafc;
  min-height: 100%;
}

@media (max-width: 600px) {
  .order-page {
    padding: 10px !important;
  }
}
</style>